import React, { Component, Row } from 'react';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import Util from '../../Util/Util';
import { withRouter } from "react-router-dom";
import Ajuda from "./../Ajuda/Ajuda.jsx";

class BotaoVisualizarItem extends React.Component {

    constructor(props) {
        super(props);
        this.ajuda = React.createRef();

        this.state = ({
            data: this.props.data,
            modalVisivel: false
        });
    }

    visualizaResultado = (data) => {

        let idArquivo = data.id;
        let moduloEfd = data.moduloEfd;
        let tipoValidacao = Util.IsNullOrEmpty(data.tipoValidacao) ? "basica" : data.tipoValidacao;

        this.props.history.push(`/resultado/${idArquivo}/${moduloEfd}/${tipoValidacao}/${false}/${this.props.origem}`);
    }

    alterarVisibilidade = (data) => {
        this.ajuda.current.alterarVisibilidadeModal(data);
        //this.setState({ modalVisivel: !this.state.modalVisivel });
    }

    visualizaErroEstrutura = (data) => {

        let idArquivo = data.id;
        let moduloEfd = data.moduloEfd;
        let tipoValidacao = data.tipoValidacao;

        this.props.history.push(`/resultadoErros/${idArquivo}/${moduloEfd}/${this.props.origem}`);
    }

    setarBotoes = (data) => {
        if (data.status == 'Finalizado')
            return (<button className="ecobtn fit vazado verde" onClick={(e) => this.visualizaResultado(data)}>Visualizar</button>);
        if (data.status == 'Erro' || data.status == 'ErroSimplesNacional')
            return (<button className="ecobtn fit vazado cinza" onClick={(e) => this.alterarVisibilidade(data)}>Erro</button>);
        else
            return (<button className="ecobtn fit vazado vermelho" onClick={(e) => this.visualizaErroEstrutura(data)}>Revisar</button>);
    }

    render() {
        return (
            <div>
                {this.setarBotoes(this.props.data)}
                <Ajuda ref={this.ajuda} />
            </div>
        );
    }
}

export default withRouter(BotaoVisualizarItem);


// WEBPACK FOOTER //
// ./src/Componente/Arquivos/BotaoVisualizar.jsx